module.exports = __webpack_public_path__ + "9871aa0e10e718b5258652e5f02df5a5.png";